import http from "../js/tools/http.js";
import getDevicedId from "./getDevicedId.js";
const { VUE_APP_SCRIPT_ENV } = process.env;
const env = VUE_APP_SCRIPT_ENV === "pro" ? "" : VUE_APP_SCRIPT_ENV;
const BASE_URL = `https://${env}analyticsapi.nfnews.com/analytics/sendRecord`;

/**
 * 发送埋点数据
 *
 * @param {*} params 参数
 * @param {Function} callback 回调函数，默认false
 */
const savePoint = (params, callback) => {
  const nowTime = Date.now();
  delete params.headers;

  http
    .get(BASE_URL, {
      deviceid: getDevicedId(),
      dataType: "1000271",
      actionTime: nowTime,
      platform: 3,
      userUuid: "",
      ...params,
    })
    .then((res) => {
      callback && callback(res.data.data);
    })
    .catch((e) => {});
};

export { savePoint, BASE_URL };
